// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22.5 2V18H6.87574L1.5 22.7038V2H22.5ZM11.9995 8.58575L9.17105 5.75732L7.75684 7.17154L10.5853 9.99996L7.75684 12.8284L9.17105 14.2426L11.9995 11.4142L14.8279 14.2426L16.2421 12.8284L13.4137 9.99996L16.2421 7.17154L14.8279 5.75732L11.9995 8.58575Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chat-clear-filled')
export default class ChatClearFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chat-clear-filled',
    }
  }
}
